import { KeyValue } from '@/main/models/common';
import {
  ContactTypeTypes,
  ContactTypeActionTypes
} from './contactTypeTypes';
import { ContactTypeDomain } from '@/main/models/request';

export function getContactType(
  request?: ContactTypeDomain,
): ContactTypeActionTypes {
  return {
    type: ContactTypeTypes.GET_CONTACT_TYPE,
    payload: { request }
  };
}

export function saveContactType(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): ContactTypeActionTypes {
  return {
    type: ContactTypeTypes.SAVE_CONTACT_TYPE,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerStatusRegister(): ContactTypeActionTypes {
  return {
    type: ContactTypeTypes.RESET_REDUCER_CONTACT_TYPE
  };
}
